import type { UserOrganizationHeaderMainRoleProps } from "./user-organization-header-main-role.type";

import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import UserRoleIcon from "@/components/UserRoleIcon";
import UserEdit from "@/features/Users/UserEdit";
import { useAuthorization } from "@/modules/authorization";
import { useSidePanel } from "@/modules/side-panel";

import { UserOrganizationHeaderCard } from "../user-organization-header-card";

export const UserOrganizationHeaderMainRole = ({
  mainRole,
  user,
}: UserOrganizationHeaderMainRoleProps) => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();
  const { canUpdateItem } = useAuthorization();

  const role = mainRole.name.split(".")[0];

  const handleClick = () => {
    openSidePanel({
      title: user.name,
      component: <UserEdit userId={user.id} />,
    });
  };

  return (
    <UserOrganizationHeaderCard
      title={t(`user:organizationRole.${role}.label`)}
      icon={<UserRoleIcon role={role} />}
      secondaryTitle={t("user:role")}
      extra={
        <Button
          size="small"
          icon={<EditOutlined />}
          onClick={handleClick}
          disabled={!canUpdateItem(user)}
        >
          {t("global:edit")}
        </Button>
      }
    >
      {t(`user:organizationRole.${role}.description`)}
    </UserOrganizationHeaderCard>
  );
};
